// extracted by mini-css-extract-plugin
module.exports =  {"link":"usbAttackTokenModal__link","footer":"usbAttackTokenModal__footer"};